import {} from "../definition/index.js";
import { addNode } from "../net/addNode.js";
import {} from "../net/index.js";
import {} from "../node/index.js";
export function addNodeFromDefinition(net, definition) {
    if (definition["@kind"] !== "NodeDefinition") {
        throw new Error([
            `[addNodeFromDefinition] I expect the definition to be NodeDefinition.`,
            ``,
            `  definition kind: ${definition["@kind"]}`,
        ].join("\n"));
    }
    return addNode(net, definition.mod, definition.name, definition.input, definition.output);
}
//# sourceMappingURL=addNodeFromDefinition.js.map